import { render, staticRenderFns } from "./science.vue?vue&type=template&id=43ce555b&scoped=true&"
import script from "./science.vue?vue&type=script&lang=js&"
export * from "./science.vue?vue&type=script&lang=js&"
import style0 from "./science.vue?vue&type=style&index=0&id=43ce555b&prod&lang=scss&scoped=true&"
import style1 from "./science.vue?vue&type=style&index=1&id=43ce555b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ce555b",
  null
  
)

export default component.exports